import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { NoContractSectionHeader } from './SectionHeader';
import { RejectionReasonField } from './RejectionReasonField';

export const NoContractContentStep2Reject = () => {
  const { setValue } = useFormContext();

  // Clear reason field when component mounts (switching from Accept to Reject)
  useEffect(() => {
    setValue('reason', '');
  }, [setValue]);

  return (
    <div className='p-24'>
      <div className='my-24'>
        <NoContractSectionHeader title='Resolution' description='Specify the reason of the rejection' />
      </div>

      <RejectionReasonField />
    </div>
  );
};
